import React from 'react'
import { APIDrinkPreset } from 'services/api/entities/catalog/packages/drinkPackage'
import { ProductPresetField } from '../ProductPresetField'
import { OnlyWithPresetsOrId } from '../eventPackage/package/common'
import { NumberField } from 'react-admin'
import { Container, Box } from '@mui/material'

type Props = {
  pkg?: OnlyWithPresetsOrId<APIDrinkPreset>
}

const DrinkPackageReadonlyPresetsList: React.FC<Props> = ({ pkg }) => {
  return (
    <Container>
      <Box display="flex" flexDirection="column">
        {pkg &&
          typeof pkg !== 'number' &&
          pkg.presets.map((preset, index) => (
            <React.Fragment key={preset.id}>
              <h3>{`${index + 1}) \n`}Preset</h3>
              <ProductPresetField record={preset} />
              {preset.variants.map((variant, index) => (
                <Box marginLeft="1.5rem" key={`drink_${variant.id}_${index}`}>
                  <h4>{`${index + 1}) \n`}Variant </h4>
                  <ProductPresetField record={variant}>
                    <h4>Drinks per person: </h4>
                    <NumberField
                      record={variant}
                      source="drinksPerPerson"
                      className="MuiTypography-body2"
                    />
                  </ProductPresetField>
                </Box>
              ))}
            </React.Fragment>
          ))}
      </Box>
    </Container>
  )
}

export default DrinkPackageReadonlyPresetsList
